import axios from 'axios'

export default {
  namespaced: true,
  state: {
    fichesAim: [],
    preparationDeFichesAim: [],
    existeFichePrecedanteEtSuivante: { existePrecedante: false, existeSuivante: false },
  },
  mutations: {
    SET_FICHES_AIMS(state, _fichesAim) {
      state.fichesAim = _fichesAim
    },
    SET_EXISTE_FICHES(state, existeFichePrecedanteEtSuivante) {
      state.existeFichePrecedanteEtSuivante = existeFichePrecedanteEtSuivante
    },
    ADD_OR_UPDATE_PREPARATION_FICHE_AIM(state, _preparationDeFichesAim) {
      const indexToUpdate = state.preparationDeFichesAim.findIndex(
        (prepa) => prepa.ficheAIMId === _preparationDeFichesAim.ficheAIMId
      )

      if (indexToUpdate >= 0) {
        state.preparationDeFichesAim.splice(indexToUpdate, 1, _preparationDeFichesAim)
      } else {
        state.preparationDeFichesAim.push(_preparationDeFichesAim)
      }
    },
    ADD_OR_UPDATE_FICHE_AIM(state, _fichesAim) {
      const indexToUpdate = state.fichesAim.findIndex((fiche) => fiche.ficheAIMId === _fichesAim.ficheAIMId)

      if (indexToUpdate >= 0) {
        state.fichesAim.splice(indexToUpdate, 1, _fichesAim)
      } else {
        state.fichesAim.push(_fichesAim)
      }
    },
  },
  getters: {
    getFicheAimByUsagerId: (state) => (_usagerId) => {
      return state.fichesAim.filter((ficheAim) => ficheAim.usager.usagerId === _usagerId)
    },
    getFicheAimById: (state) => (_ficheAimId) => {
      return state.fichesAim.find((ficheAim) => ficheAim.ficheAIMId === _ficheAimId)
    },
    getExisteFichePrecedanteEtSuivante: (state) => {
      return state.existeFichePrecedanteEtSuivante
    },
  },
  actions: {
    async initializerLaFicheAIMSuivante({ commit }, initializerLaFicheAIMSuivanteCommand) {
      return await axios
        .post(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/`, initializerLaFicheAIMSuivanteCommand, {
          validateStatus: (status) => status === 200,
        })
        .then((response) => {
          commit('ADD_OR_UPDATE_FICHE_AIM', response.data)
        })
        .catch((error) => {
          switch (error.response.data.errorName) {
            case 'ModeleAimManquantException':
              return {
                name: error.response.data.errorName,
                serviceConcerne: error.response.data.serviceConcerne,
              }
            default:
              throw new Error('Unhandled error wile creating next fiche aim')
          }
        })
    },
    fetchFicheAimsUsagerId({ commit }, _usagerId) {
      return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/usager/` + _usagerId).then((response) => {
        commit('SET_FICHES_AIMS', response.data)
      })
    },
    existeFichesAdjacentes({ commit }, ficheAimId) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/` + ficheAimId + '/existentFichesPrecedenteEtSuivante')
        .then((response) => {
          commit('SET_EXISTE_FICHES', response.data)
        })
    },
    fetchFicheAimByUsagerIdAndMoisAndAnnee({ commit }, { _usagerId, _mois, _annee }) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM`, {
          params: {
            usagerId: _usagerId,
            mois: _mois,
            annee: _annee,
          },
        })
        .then((response) => {
          commit('ADD_OR_UPDATE_FICHE_AIM', response.data)
          return response.data
        })
        .catch(() => {
          return null
        })
    },
    fetchFicheAimByFicheId({ commit }, _ficheAimId) {
      return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/` + _ficheAimId).then((response) => {
        commit('ADD_OR_UPDATE_FICHE_AIM', response.data)
      })
    },
    fetchFicheAimBySearch({ commit }, _search) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/search`, {
          params: {
            usagerId: _search.usagerId,
            etablissementId: _search.etablissementId,
            posteAimId: _search.posteAimId != null ? _search.posteAimId : null,
          },
        })
        .then((response) => {
          commit('SET_FICHES_AIMS', response.data)
        })
    },
    fetchPreparationFicheAimsUsagerId({ commit }, _ficheAimId) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/` + _ficheAimId + `/preparation`)
        .then((response) => {
          commit('ADD_OR_UPDATE_PREPARATION_FICHE_AIM', response.data)
        })
    },
    ajusterFicheAIM({ commit }, _ajusterFicheAimCommand) {
      return axios
        .post(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/` + _ajusterFicheAimCommand.ficheAIMId + `/ajuster`,
          _ajusterFicheAimCommand
        )
        .then((response) => {
          commit('ADD_OR_UPDATE_FICHE_AIM', response.data)
        })
    },
    retirerAjustement({ commit }, _retirerUnAjustementDUneFicheAIMCommand) {
      return axios
        .put(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/ficheAIM/` +
            _retirerUnAjustementDUneFicheAIMCommand.ficheAIMId +
            `/retirerAjustement`,
          _retirerUnAjustementDUneFicheAIMCommand
        )
        .then((response) => {
          commit('ADD_OR_UPDATE_FICHE_AIM', response.data)
        })
    },
  },
}
